import { render, staticRenderFns } from "./RulesForm.vue?vue&type=template&id=17f609ff"
import script from "./RulesForm.vue?vue&type=script&lang=js"
export * from "./RulesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports